<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">警示教育></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>东津新区通报5起形式主义官僚主义问题典型案例</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>
          <b>1.东津新区东津镇中洲村党支部书记、村委会主任刘长富乱作为问题。</b>
        </h3>
        <h3>2017年6月，东津镇中洲村党支部书记、村委会主任刘长富，未经村“两委”班子和村民议事会议讨论，擅自将村集体道路使用权承包给某砂石公司。2020年1月，东津镇纪委给予刘长富党内严重警告处分。.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>
          <b>2.东津新区东津镇食品所原党支部书记叶荣郭乱作为问题。</b>
        </h3>
        <h3>2004年10月至2019年12月，叶荣郭任东津镇食品所党支部书记期间，破坏社会主义经济秩序，非法将东津镇食品所霸王食品点国有土地使用权出售；未经批准占用东津镇食品所院内国有土地建房；违反组织纪律，违规为东津镇食品所在职职工的5名子女缴纳社保；违反工作纪律，为东津镇食品所10名职工（含退休）缴纳社保个人应缴部分费用，并将东津镇中心卫生院职工赵某纳入东津镇食品所全额缴纳社保。2020年4月，东津新区纪检监察工委给予叶荣郭党内严重警告处分。.76%，同比增长7.25%。主要原因是由于各地各单位受理信访举报的时间不同，信访人担心信访件未被受理或重视不够，在等待的过程中重复反映问题，导致重复访数量居高不下。2019年越级访15件次，同比下降57.14%。主要原因是枣阳市纪委监委领导班子认真执行定期下访接访制度，主要领导每周四固定接访，去年共接待群众面访36批次581人次，上访对象无一人越级访，有效缓解了全市大信访压力，越级访乱象得到了遏止；二是自办案件增加，上级转交件下降。2019年共受理信访举报995件，同比基本持平。其中本级自收573件，占57.59%，同比增长57.85%；上级转交办422件，占42.41%，同比下降33.02%。主要原因是随着全面从严治党不断向纵深推进，信访干部履职尽责意识不断增强，办信办访能力增强，加之信访渠道的通畅及日益拓宽，干部主动接访、带案下访、重点约访的机制发挥了积极作用，群众在本级信访诉求能够得到有效解决，越级向上反映问题大幅减少。三是信访反映村级干部增加，乡科级干部减少。2019年信访反映村（社区）人员419件，同比增长16.06%，反映乡科级干部198件，同比下降30.5%。从中不难看出在全面从严治党的高压态势下，不敢腐的震慑已经形成，不能腐的笼子正在扎牢，不想腐的自觉逐步增强，但从村干部信访举报持续增长的趋势显示，全面从严治党“最后一米”的问题还不够彻底，违反群众纪律和廉洁纪律类问题仍然居高不下，破坏了党群干群关系，蚕食了群众切身利益。 闵翼飞）</h3>
        <h3>
          <b>3.东津新区东津镇柳沟村党支部书记、村委会主任万清国履职不力问题。</b>
        </h3>
        <h3>2019年9月，东津镇柳沟村三组原组长肖某某违规建房，柳沟村党支部书记、村委会主任万清国监管不力，给全区查违控违工作造成不良影响。万清国还存在其他违纪问题。2020年4月，东津镇纪委给予万清国党内严重警告处分。</h3>
        <h3>
          <b>4.襄阳市畜牧良种场望城队队长王华良等2人乱作为问题。</b>
        </h3>
        <h3>2015年5月，襄阳市畜牧良种场望城队队长王华良、会计刘加军在未报财政部门批准，也未委托有资质的中介对土地进行评估的情况下，将80亩国有土地对外出租。2020年5月，东津新区纪检监察工委对王华良、刘加军诫勉谈话。</h3>
        <h3>
          <b>5.东津新区东津镇秦咀村党支部书记、村委会主任邹正江履职不力问题。</b>
        </h3>
        <h3>村民邹某某在未签合同、未交承包费的情况下，长期占用村集体百亩堰塘近5年；2018年春，秦咀村水库坝埂加固工程未进行招投标程序。邹正江作为秦咀村党支部书记、村委会主任履职不力，工作失职。2020年5月，东津新区纪检监察工委对邹正江诫勉谈话。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumWarning" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>